<template>
  <div>
    <h1 class="pb-3">Controle de qualidade</h1>
    <div class="text text-justify">
      <p>
        Os técnicos do CPGeo realizam em cada linha 2D ou cubo sísmico 3D, um
        intensivo trabalho de controle de qualidade dos dados, com o objetivo de
        obter a melhor imagem possível.
      </p>
      <p>
        Esse controle de qualidade é realizado em várias etapas do
        processamento, de acordo com a lista a seguir:
      </p>
      <BeautifulList v-bind:items="items" />
      <p>
        Todo o processamento e controle de qualidade é executado obedecendo às
        especificações dos fluxogramas acima, utilizando as aplicações do pacote
        HFS – de propriedade do CPGeo, do pacote comercial ProMax – da
        Halliburton e do pacote Geodepth – da Paradigm.
      </p>
    </div>
  </div>
</template>

<script>
import BeautifulList from "@/components/BeautifulList.vue";

export default {
  name: "ControleQualidade",
  components: {
    BeautifulList,
  },
  data() {
    return {
      items: [
        { id: 1, text: "Controle de qualidade da geometria (mapas)" },
        {
          id: 2,
          text:
            "Checagem de elevações, em casos de dúvidas, aferindo-as com valores obtidos de leitura em imagens de satélites",
        },
        {
          id: 3,
          text:
            "Registros selecionados para controle de qualidade da edição de traços;",
        },
        {
          id: 4,
          text: "Controle de qualidade da solução de estáticas de refração",
        },
        {
          id: 5,
          text: "Controle de qualidade das análise de velocidade a cada 0,5 km",
        },
        { id: 6, text: "Empilhamento CDP para verificação das velocidades" },
        { id: 7, text: "Testes dos tratamentos de ruídos" },
        { id: 8, text: "Testes de deconvolução" },
        {
          id: 9,
          text:
            "Testes de suavização da velocidade para migração (seções e time-slices)",
        },
        { id: 10, text: "Janelas de empilhamento com estáticas residuais" },
        { id: 11, text: "Testes de mute" },
        {
          id: 12,
          text:
            "Testes dos parâmetros de migração tais como operador e abertura",
        },
        {
          id: 13,
          text:
            "Análise de velocidades residuais, após Migração pré-empilhamento, a cada 500 metros",
        },
        { id: 14, text: "Testes dos filtros pós-processos" },
        {
          id: 15,
          text: "Aferições dos cruzamentos, no caso de linhas 2D (mis-ties)",
        },
      ],
    };
  },
};
</script>
